import type { WShopAdditionalSearchOptionsTranslations } from "./pl";

export const de: WShopAdditionalSearchOptionsTranslations = {
  title: "Filter",
  emptyContext: "Filter sind nur innerhalb einer Shop-Kategorie verfügbar.",
  sections: {
    query: "Suchen",
    categorys: "Kategorien",
    producent: "Hersteller",
    variants: "Merkmale",
    price: "Preis",
  },
  activeHeader: "Aktive Filter",
  clearAll: "Alle löschen",
  removeChip: "Filter entfernen",
  queryPlaceholder: "Suchbegriff eingeben...",
  priceFromLabel: "Von",
  priceToLabel: "Bis",
  buttons: {
    apply: "Filtern",
    cancel: "Abbrechen",
  },
  emptyFacet: "Keine Optionen verfügbar.",
};
